import { Separator } from "@/components/ui/separator";

interface DateSeparatorProps {
  date: Date;
}

export function DateSeparator({ date }: DateSeparatorProps) {
  const label = date.toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="flex items-center gap-3 py-2">
      <Separator className="flex-1" />
      <span className="text-[11px] font-normal text-muted-foreground">
        {label}
      </span>
      <Separator className="flex-1" />
    </div>
  );
}
